import React from "react";

import styles from "./PageHeader.module.css";

export const PageHeader = ({ title, children, className }) => {
  return (
    <div className={`${styles.pageHeader} ${className || ""}`}>
      {title && <h3 className={styles.pageHeaderTitle}>{title}</h3>}
      {children}
    </div>
  );
};
